"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {GA_TRACKING_ID} from "~/lib/gtag";
import {GA_CSR_TRACKING_ID} from "~/lib/gtagCSRDashboard";


export default function GoogleAnalytics() {
    const pathname = usePathname();

    // The deployment's service network id (e.g. DTE). This component is mounted
    // in the root layout, outside any SessionProvider, so we read the build-time
    // env var rather than the per-user session. Lets GA identify the data per-utility.
    const serviceNetworkId = process.env.NEXT_PUBLIC_SNID;

    useEffect(() => {
        if (typeof window.gtag !== 'undefined') {
            // v2 is the default UI for all users, so consumer sessions always report "new_bwai".
            const consumerUI = "new_bwai";

            if (pathname.includes('/cs-dashboard')) {
                window.gtag('config', GA_CSR_TRACKING_ID, {
                    page_path: pathname,
                    service_network_id: serviceNetworkId,
                });
            } else {
                // Set session-level dimension
                window.gtag('config', GA_TRACKING_ID, {
                    consumerUI: consumerUI,
                    service_network_id: serviceNetworkId,
                });

                // Then track pageview
                window.gtag('config', GA_TRACKING_ID, {
                    page_path: pathname,
                    service_network_id: serviceNetworkId,
                });
            }
        }
    }, [pathname, serviceNetworkId]);

    return null;
}
